import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {CGE} from "../CGE";
import { useModal } from "@clayui/modal";
import './globalAlert.scss';
import AlertModal from '../AlertModal';

const GlobalAlert = props => {
    const { toastList, position, autoDelete, autoDeleteTime, modalList} = props;
    const [list, setList] = useState(toastList);
    const [listModal, setListModal] = useState(modalList);
    const [currentModal, setCurrentModal] = useState([]);
    const [currentPositionModal, setCurrentPositionModal] = useState(0);
    const [visibleModal, setVisibleModal] = React.useState(false);
    const { observer, onClose } = useModal({
        onClose: () => {
            setVisibleModal(false);
            if((listModal.length - 1) > currentPositionModal){
                setCurrentPositionModal(currentPositionModal+1)
            }
        }
    });

    useEffect(() => {
        let uniqueObjArray = [
            ...new Map(toastList.map((item) => [item["description"], item])).values(),
        ];
        setList([...uniqueObjArray]);
        
    }, [toastList]);

    useEffect(() => {
        setListModal([...modalList]);
    }, [ modalList]);

    React.useEffect(() => {
        if(listModal.length === 1){
            setCurrentModal(listModal[0])
            setVisibleModal(true)
        } else if(((listModal.length - 1) > currentPositionModal) && !visibleModal){
            setCurrentPositionModal(currentPositionModal+1)
        }
    },[listModal])

    React.useEffect(() => {
        if(currentPositionModal > 0){
            setCurrentModal(listModal[currentPositionModal])
            setVisibleModal(true)
        }
    }, [currentPositionModal])

    useEffect(() => {
        const interval = setInterval(() => {
            if (autoDelete && toastList.length && list.length) {
                deleteToast(toastList[0].id);
            }
        }, autoDeleteTime);
        
        return () => {
            clearInterval(interval);
        }

        // eslint-disable-next-line
    }, [toastList, autoDelete, autoDeleteTime, list]);

    const deleteToast = id => {
        const listItemIndex = list.findIndex(e => e.id === id);
        const toastListItem = toastList.findIndex(e => e.id === id);
        list.splice(listItemIndex, 1);
        toastList.splice(toastListItem, 1);
        setList([...list]);
    }

    return (
        <>
            {visibleModal &&
                <AlertModal
                titleModal={currentModal?.title}
                observer={observer}
                onClose={onClose}
                status={currentModal?.status}
                msgModal={currentModal?.description}
                />
            }
            <div className={`notification-container ${position}`}>
                {
                    list.map((toast, i) =>     
                        <div 
                            key={i}
                            className={`notification toast ${position}`}
                            style={{ backgroundColor: toast.backgroundColor }}
                        >
                            <button onClick={() => deleteToast(toast.id)}>
                                X
                            </button>
                            <div className="notification-image">
                                <CGE.Icon
                                    style={{ fontSize: '30px' }}
                                    name={toast.icon}
                                />
                            </div>
                            <div>
                                <p className="notification-title">{toast.title}</p>
                                <p className="notification-message">
                                    <CGE.RenderContent textContent={toast.description} />
                                </p>
                            </div>
                        </div>
                    )
                }
            </div>
        </>
    );
}

GlobalAlert.propTypes = {
    toastList: PropTypes.array.isRequired,
    modalList:PropTypes.array.isRequired,
    position: PropTypes.string.isRequired,
    autoDelete: PropTypes.bool,
    autoDeleteTime: PropTypes.number
}

export default GlobalAlert;